// ============================================================
// StatutDevis — changer le statut depuis la LISTE. 6 octobre 2026.
// ------------------------------------------------------------
// Philippe ouvrait chaque devis pour le passer en « accepté ». La liste
// porte désormais un sélecteur par ligne. Même route que la fiche
// (`POST /devis/:id/statut`) : passer en « envoyé » y subit le même
// contrôle de complétude que le PDF, et « perdu » demande son motif.
//
// « Enregistré » n'est pas un statut (`enregistre_at`) : sur un brouillon
// enregistré, l'option du brouillon s'appelle « Enregistré », et c'est à
// côté d'elle que vit « En production ».
// ============================================================
import { useState } from 'react';
import { Select } from '../../ui/TextField.jsx';
import { api } from '../../lib/api.js';
import { OPTIONS_STATUT } from './statuts.js';

export function StatutDevis({ devis, toast, onChange }) {
  const [envoi, setEnvoi] = useState(false);
  const options = OPTIONS_STATUT.map((o) => (o.value === 'draft' && devis.enregistre_at
    ? { ...o, label: 'Enregistré' } : o));
  // Un statut que la liste ne propose pas (« expiré ») reste affiché.
  if (!options.some((o) => o.value === devis.status)) options.push({ value: devis.status, label: devis.status });

  async function changer(status) {
    if (status === devis.status) return;
    let motif = null;
    if (status === 'lost') {
      motif = window.prompt(`Motif de la perte de ${devis.reference} ?`);
      if (!motif) return;
    }
    setEnvoi(true);
    try {
      await api.post(`/devis/${devis.id}/statut`, { status, lost_reason: motif });
      toast.success(`${devis.reference} : statut mis à jour.`);
      await onChange?.();
    } catch (err) {
      toast.error(`${devis.reference} : ${err.message}`);
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <Select
      label={`Statut du devis ${devis.reference}`}
      hideLabel
      value={devis.status}
      disabled={envoi}
      options={options}
      onChange={(e) => changer(e.target.value)}
    />
  );
}

export default StatutDevis;
